<div class="custom-mat-dialog-form">
  <div>
    <div>
      Controller type local name
      <br />
      <h4 class="not-translated">{{this.data.ControllerTypeLocal}}</h4>
      <br />
      Correspond to controller type harmonized value: <br />
      <br />
    </div>
  </div>
  <div>
    <form [formGroup]="form" (ngSubmit)="onSubmit()">

      <div class="mt-2">

        <mat-select placeholder="Please select" style="width:300px;" class='form-control'
          name="Controller Type" required formControlName="ControllerType">
          @for (c of controllerTypes; track c; let i = $index) {
            <mat-option value="{{c.BK}}">
              {{c.Description}}
            </mat-option>
          }
        </mat-select>
      </div>

      <br />


      <div class="mt-2 right">
        <button type="button"
          class="btn btn-danger"
          (click)="onNoClick()">
          Cancel
        </button>
        <button type="button"
          class="btn btn-primary"
          (click)="onSubmit()">
          SAVE
        </button>
      </div>
    </form>
  </div>
</div>
